import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const RatioRecord = Record({
  quick: undefined,
});

export default class Ratio extends RatioRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject), {});

    return new Ratio(hydrated);
  }
}
